const robotsString = "index,follow";
const HOST_NAME = "https://shop.lululemon.com";

/**
 * Generates href entries for alternate language versions of a slug.
 *
 * @param {string} slug - The slug of the page or resource.
 * @return {Array} - An array of href entries, each containing the rel, href, and hreflang properties.
 */
export function generateHrefEntries(slug) {
  const HREF_LANGS = ["en-US", "en-CA", "fr-CA"];

  const isEnUS = (hrefLang) =>
    hrefLang !== "en-US" ? `/${hrefLang.toLowerCase()}` : "";
  const hrefEntries = HREF_LANGS.map((hrefLang) => ({
    rel: "alternate",
    href: `${HOST_NAME}${isEnUS(hrefLang)}${slug}`,
    hreflang: hrefLang
  }));
  hrefEntries.push({
    rel: "alternate",
    hreflang: "x-default",
    href: `${HOST_NAME}${slug}`
  });
  return hrefEntries;
}

export const storeMeta = (store) => {
  const { storeName, city, state, slug, isExperiential } = store;
  return {
    title: `lululemon ${storeName} ${
      isExperiential ? `Experiential` : ``
    } Store in ${city}, ${state}`,
    description: `Brick and mortar reimagined. Our ${
      isExperiential ? `experiential ` : ``
    }stores are a space for wellbeing. Stop by to shop and stay to sweat, eat and meditate. Select stores only.`,
    canonicalPath: slug,
    robots: robotsString,
    hrefLangEntries: generateHrefEntries(slug)
  };
};
export const spaceMeta = ({ storeName, spaceName, storeSlug, city, state }) => {
  const slug = `${storeSlug}/spaces/${spaceName
    .replace(/\W/g, "-")
    .toLowerCase()}`;
  return {
    title: `lululemon ${storeName} Wellness Space`,
    description: `Check out our ${storeName} store space in ${city}, ${state} for wellness events and workshops around your area.`,
    canonicalPath: slug,
    robots: robotsString,
    hrefLangEntries: generateHrefEntries(slug)
  };
};
export const storeLocatorMeta = () => {
  const SLUG = "/stores";
  return {
    title: `Find A Store Nearby | lululemon`,
    description: `Innovative technical gear is just around the corner. Come visit us at one of our lululemon stores. Shop online & pick up in store.`,
    canonicalPath: SLUG,
    robots: robotsString,
    hrefLangEntries: generateHrefEntries(SLUG)
  };
};

export const storeListMeta = () => {
  const SLUG = "/stores/all-lululemon-stores";
  return {
    title: "Stores in Canada & United States | lululemon",
    description:
      "Find a full list of our lululemon stores across the coast. Browse our North America locations to shop online and pick up in store!",
    canonicalPath: SLUG,
    robots: robotsString,
    hrefLangEntries: generateHrefEntries(SLUG)
  };
};
